import snakeCase from 'lodash/snakeCase';

import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';
import { ProductsFilters, } from 'store/ducks/products/collection/types';
import { convertToCase, makeImagesCollectionToDict, } from 'common/functions';

import {
    ProductsImageType as _ProductsImageType,
    ProductsOriginalImageType as _ProductsOriginalImageType,
    ProductsItemType as _ProductsItemType,
    ProductsType as _ProductsType,
    ProductsImageItemType as _ProductsImageItemType,
    ProductsAttributeType as _ProductsAttributeType,
    ProductsDetailType as _ProductsDetailType,
    ProductsImageSizeType as _ProductsImageSizeType,
    ProductsItemAvailabilityType as _ProductsItemAvailabilityType,
    ProductsItemTaxons as _ProductsItemTaxons,
    ProductsLabelType as _ProductsLabelType,
    ProductsLinkType as _ProductsLinkType,
    ProductsOriginalPriceType as _ProductsOriginalPriceType,
    ProductsPriceType as _ProductsPriceType,
    ProductsProductItemType as _ProductsProductItemType,
} from 'common/types';

// Only for backward compatibility
export type ProductsImageType = _ProductsImageType;
export type ProductsOriginalImageType = _ProductsOriginalImageType;
export type ProductsItemType = _ProductsItemType;
export type ProductsType = _ProductsType;
export type ProductsImageItemType = _ProductsImageItemType;
export type ProductsAttributeType = _ProductsAttributeType;
export type ProductsDetailType = _ProductsDetailType;
export type ProductsImageSizeType = _ProductsImageSizeType;
export type ProductsItemAvailabilityType = _ProductsItemAvailabilityType;
export type ProductsItemTaxons = _ProductsItemTaxons;
export type ProductsLabelType = _ProductsLabelType;
export type ProductsLinkType = _ProductsLinkType;
export type ProductsOriginalPriceType = _ProductsOriginalPriceType;
export type ProductsPriceType = _ProductsPriceType;
export type ProductsProductItemType = _ProductsProductItemType;

export const ATTRIBUTES_CODES_MAP = Object.freeze({
    SCHOOL_LEVEL: 'school_level',
    SCHOOL_SUBJECTS: 'school_subjects',
    BOOK_AUTHOR: 'book_author',
    BOOK_ISBN: 'book_isbn',
    BOOK_SERIES: 'book_series',
    BOOK_PAGES: 'book_pages',
    BOOK_TYPES: 'book_types',
});

export const PRODUCTS_PRODUCT_ITEM_MAP = Object.freeze({
    BOOK: 'BOOK',
    GRANT_APP: 'GRANT_APP',
    GRANT_SET: 'GRANT_SET',
});

const mapItems = (item: _ProductsItemType<Array<_ProductsOriginalImageType>>) => ({
    ...item,
    images: item.images.reduce(makeImagesCollectionToDict, {})
});
const transformCollectionImagesToObjectNotation = (data: _ProductsType<Array<_ProductsOriginalImageType>>) => !data ? null : ({
    ...data,
    items: data.items.map(mapItems),
});

class Products extends BaseRepositoryClass implements RepositoryType {
    private static _prepareParams(params: ProductsFilters) {
        return params && convertToCase(snakeCase, params);
    }

    getAll(queryParam: ProductsFilters | any) {

        const transformers = {
            response: [
                (data: any) => {
                    if (!data) {
                        return null;
                    }

                    const parsed = JSON.parse(data);

                    return [ 'code', 'message', ].some(prop => prop in parsed) ? null : parsed;
                },
                transformCollectionImagesToObjectNotation,
            ],
        };

        const params = Products._prepareParams(queryParam);

        return this
            .requester
            .setTransformers(transformers)
            .get<ProductsType>('grant/products', { params, });
    }
}

export default Products;
